import i18n from 'i18next';
import Backend from 'i18next-http-backend';
import PhraseInContextEditorPostProcessor from 'i18next-phrase-in-context-editor-post-processor';
import { initReactI18next } from 'react-i18next';
import { world } from './languages';
import serializeQueryParams from './utils/url/serialize-query-params';

const checkForInlineEditor = () => {
    const params = serializeQueryParams();

    if (params.runPhraseEditor) {
        window.localStorage.setItem('phraseEditor', String(true));
    }

    if (params.stopPhraseEditor) {
        window.localStorage.removeItem('phraseEditor');
    }

    return Boolean(window.localStorage.getItem('phraseEditor'));
};

i18n.use(Backend)
    .use(initReactI18next)
    .use(
        new PhraseInContextEditorPostProcessor({
            accountId: '1be2dd87c9a365ee7792688314f848e0',
            autoLowercase: false,
            fullReparse: true,
            phraseEnabled: checkForInlineEditor(),
            projectId: 'e7632bb4ba3b25327802db9be87f13d6'
        })
    )
    .init({
        debug: false,
        // we used fallbackNS for cases when translation function is called not from component with bound namespace, but from external file ---> and in this case function i18n.t will search in these files. This fix helps Phrase's "inContextEditor" understand keys (keys like namespace:key were ignored)
        fallbackNS: [
            'header',
            'search',
            'author-page',
            'common',
            'seller',
            'material-page',
            'footer',
            'cabinet-materials',
            'cabinet-settings'
        ],

        interpolation: {
            escapeValue: false
        },

        lng: world,

        postProcess: ['phraseInContextEditor'],
        resources: {}
    });

window.i18n = i18n;

export default i18n;
